import type { EventType } from '../../../configs/adTagEvents';
import type { AdTagType } from '../../../configs/adTagTypes';
import type { CreativeType } from '../../../configs/creativeTypes';
import type { AdTypeV5 } from '../../graphql/types';

export enum DcmTagSheetCreativeSource {
  VAST = 'VAST',
  SITE_SERVED = 'SITE_SERVED',
}

export type DcmTagSheetCreative = {
  creativeName: string;
  source: DcmTagSheetCreativeSource;
  creativeUrl?: string;
  creativeType: CreativeType;
};

export type DcmTagSheetTag = {
  type: AdTagType;
  tagUrl: string;
  position?: EventType;
};

export type DcmTagSheetAd = {
  placementId: string;
  placementName: string;
  placementCompatibility: string;
  dimensions: string;
  site: string;
  startDate: string;
  endDate: string;
  adName: string;
  adType: AdTypeV5;
  creative: DcmTagSheetCreative;
  tags: DcmTagSheetTag[];
};

export type DcmTagSheetLineItem = {
  lineItemId: string;
  name: string;
  adProduct?: string;
  startDate?: string;
  endDate?: string;
  timezone?: string;
  ads: DcmTagSheetAd[];
};

export type DcmTagSheetVendor = {
  code: string;
  name: string;
};

export type DcmTagSheetParseResult = {
  unmappedAds: DcmTagSheetAd[];
  lineItems: DcmTagSheetLineItem[];
  vendor: DcmTagSheetVendor;
};

export type ParseTagSheetErrorDetail = {
  field: string;
};

export type ParseTagSheetErrorResponse = {
  name: string;
  message: string;
  details?: ParseTagSheetErrorDetail[];
};
